module.exports = __webpack_public_path__ + "static/media/7.3ac2a6f0.jpg";